// removed by extract-text-webpack-plugin
module.exports = {"TextAndImageBlock":"src-components-TextAndImageBlock----TextAndImageBlock-module---TextAndImageBlock---3wwKj","text":"src-components-TextAndImageBlock----TextAndImageBlock-module---text---3tLrq","img":"src-components-TextAndImageBlock----TextAndImageBlock-module---img---18r3I","left":"src-components-TextAndImageBlock----TextAndImageBlock-module---left---3GOB5","right":"src-components-TextAndImageBlock----TextAndImageBlock-module---right---3vZcp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TextAndImageBlock/TextAndImageBlock.module.css
// module id = 391
// module chunks = 35783957827783